import React from "react";

import API from "@beardeddevops/react.api";
import Types from "constants/Types";
import Framework from "@beardeddevops/react.framework";
import {Button, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import ReactTable from "react-table";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CollectionOverride from "components/CollectionOverride";
import QRCode from "react-qr-code";


export default class TwoStepAuth extends CollectionOverride {
	constructor(props) {
		let model = new API.BuildClass(Types.Accounts_Two_Step_Auth._name, API.RequestType.READ_ALL);
		super(props, model);
		this.state.limit = 5;
		this.state.methodOpen = false;
		this.state.setupOpen = false;
		this.state.setupUser = null;
		this.state.setupSecret = '';
		this.state.setupUri = '';
		this.state.setupMethod = '';
		this.state.twoStepCode = '';
		this.state.twoStepError = '';
		this.limit = 5;
	}

	openMethodChoice = user => () => {
		this.setState({
			methodOpen: true,
			setupUser: user,
			twoStepError: '',
			twoStepCode: '',
		});
	};

	setModelTarget = target => {
		this.model.object.pkey = target.pkey;
		this.model.object.binary_id = target.binary_id;
		this.model.object.user = target.two_step_target === 'account' ? '' : target.pkey;
		this.model.object.user_binary_id = target.two_step_target === 'account' ? '' : target.binary_id;
		this.model.object.two_step_target = target.two_step_target || 'user';
	};

	clearModelTarget = () => {
		this.model.object.pkey = this.model.object.binary_id = this.model.object.user = this.model.object.user_binary_id = this.model.object.two_step_target = '';
	};

	startSetup = async () => {
		const {setupUser} = this.state;
		if (!setupUser) {
			return;
		}

		this.setModelTarget(setupUser);
		this.setState({twoStepError: '', twoStepCode: ''});

		try {
			const setup = await this.model.submit(null, 'POST_SETUP', true);
			this.setState({
				methodOpen: false,
				setupOpen: true,
				setupMethod: 'authenticator',
				setupSecret: setup.secret,
				setupUri: setup.otpauth_uri,
			});
		} catch (error) {
			this.setState({twoStepError: error.message});
		}

		this.clearModelTarget();
	};

	enableEmail = async () => {
		const {setupUser} = this.state;
		if (!setupUser) {
			return;
		}

		this.setModelTarget(setupUser);
		this.setState({twoStepError: '', twoStepCode: ''});

		try {
			await this.model.submit(null, 'POST_ENABLE_EMAIL', true);
			this.setState({
				methodOpen: false,
				setupOpen: true,
				setupMethod: 'email',
				setupSecret: '',
				setupUri: '',
				twoStepCode: '',
				twoStepError: '',
			});
		} catch (error) {
			this.setState({twoStepError: error.message});
		}

		this.clearModelTarget();
	};

	verifySetup = async () => {
		const {setupUser, twoStepCode} = this.state;
		if (!setupUser) {
			return;
		}

		this.setModelTarget(setupUser);
		this.model.object.two_step_code = twoStepCode;

		try {
			await this.model.submit(null, this.state.setupMethod === 'email' ? 'POST_VERIFY_EMAIL_SETUP' : 'POST_VERIFY_SETUP', true);
			this.closeSetup();
			this.reloadTable();
		} catch (error) {
			this.setState({twoStepError: error.message});
		}

		this.clearModelTarget();
		this.model.object.two_step_code = '';
	};

	disableAuthenticator = target => async () => {
		this.setModelTarget(target);

		try {
			await this.model.submit(null, 'POST_DISABLE', true);
			this.reloadTable();
		} catch (error) {
		}

		this.clearModelTarget();
	};

	closeSetup = () => {
		this.setState({
			methodOpen: false,
			setupOpen: false,
			setupUser: null,
			setupSecret: '',
			setupUri: '',
			setupMethod: '',
			twoStepCode: '',
			twoStepError: '',
		});
	};

	render() {
		const {data, pages, limit, loading, methodOpen, setupOpen, setupUser, setupSecret, setupUri, setupMethod, twoStepCode, twoStepError} = this.state;
		const columns = [
			{
				Header: "First",
				id: "name_first",
				accessor: obj => (obj.name_first)
			},
			{
				Header: "Last",
				id: "name_last",
				accessor: obj => (obj.name_last)
			},
			{
				Header: "Type",
				id: "two_step_target",
				accessor: obj => obj.two_step_target === 'account' ? 'Owner' : 'User'
			},
			{
				Header: "Email",
				id: "email",
				accessor: obj => (obj.email)
			},
			{
				Header: "",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 40,
				Cell: props =>
						props.original.authy_enabled ?
							<span>
								<Button color="green-meadow" size={"sm"} block={true}
									onClick={this.disableAuthenticator(props.original)}>
									<i className={"fa fa-lock"}/></Button>
							</span>
						:
						<span>
							<Button color="danger" size={"sm"} block={true} onClick={this.openMethodChoice(props.original)}>
								<i className={"fa fa-unlock"}/></Button>
						</span>
			},
		];

		return (
			<Card>
				<CardContent>
					<div className="table-bar">
						<div className="d-flex">
							{this.renderSearch('Authenticator App 2FA', "")}
							{this.renderHeaderRight("Authenticator App 2FA", columns)}
						</div>
					</div>
					<ReactTable
						key={this.state.key}
						columns={columns}
						manual // Forces table not to paginate or sort automatically, so we can handle it server-side
						data={data}
						pages={pages} // Display the total number of pages
						loading={loading} // Display the loading overlay when we need it
						loadingText="Requesting Data"
						onFetchData={this.fetchData} // Request new data when things change
						onPageSizeChange={this.onPageSizeChange}
						onSortedChange={this.onSortedChange}
						page={this.state.page}
						onPageChange={this.onPageChange}
						expanderDefaults={{
							sortable: true,
							resizable: true,
							filterable: false,
							width: undefined
						}}
						defaultSorted={[
							{
								id: this.model.sort,
								desc: this.model.order === 'desc'
							}
						]}
						showPagination={true}
						showPaginationTop={false}
						showPaginationBottom={true}
						showPageSizeOptions={true}
						defaultPageSize={limit}
						pageSize={limit}
						pageSizeOptions={[5, 20, 50, 100, 500, 1000]}
						className="-striped -highlight"
					/>

					<Framework.Elements.LoadingSpinner isLoading={loading}/>

					<Modal isOpen={methodOpen} toggle={this.closeSetup}>
						<ModalHeader toggle={this.closeSetup}>
							Choose 2FA Method
						</ModalHeader>
						<ModalBody>
							<p>
								Enable two-factor authentication for {setupUser ? setupUser.email : 'this user'}.
							</p>
							{twoStepError && <div className="text-danger">{twoStepError}</div>}
						</ModalBody>
						<ModalFooter>
							<Button color="secondary" onClick={this.closeSetup}>Cancel</Button>
							<Button color="primary" onClick={this.startSetup}>Authenticator App</Button>
							<Button color="primary" onClick={this.enableEmail}>Email Code</Button>
						</ModalFooter>
					</Modal>

					<Modal isOpen={setupOpen} toggle={this.closeSetup}>
						<ModalHeader toggle={this.closeSetup}>
							{setupMethod === 'email' ? 'Email Code Setup' : 'Authenticator App Setup'}
						</ModalHeader>
						<ModalBody>
							{setupMethod === 'email' ?
								<p>
									A setup code was sent to {setupUser ? setupUser.email : 'this user'}. Enter that code to confirm the mailbox can receive 2FA codes.
								</p>
								:
								<span>
									<p>
										Scan this QR code with Google Authenticator, Microsoft Authenticator, Authy, 1Password, or another authenticator app.
									</p>
									<div style={{display: 'flex', justifyContent: 'center', padding: '15px'}}>
										{setupUri && <QRCode value={setupUri} size={180}/>}
									</div>
									<div className="form-group">
										<label>Manual setup key</label>
										<input className="form-control" readOnly value={setupSecret}/>
									</div>
								</span>}
							<div className="form-group">
								<label>{setupMethod === 'email' ? 'Enter the emailed 6-digit code' : `Enter the 6-digit code for ${setupUser ? setupUser.email : 'this user'}`}</label>
								<input
									className="form-control"
									value={twoStepCode}
									onChange={event => this.setState({
										twoStepCode: event.target.value.replace(/\D/g, '').slice(0, 6),
										twoStepError: ''
									})}
								/>
							</div>
							{twoStepError && <div className="text-danger">{twoStepError}</div>}
						</ModalBody>
						<ModalFooter>
							<Button color="secondary" onClick={this.closeSetup}>Cancel</Button>
							<Button color="primary" onClick={this.verifySetup} disabled={twoStepCode.length !== 6}>Verify & Enable</Button>
						</ModalFooter>
					</Modal>
				</CardContent>
			</Card>
		)
	}
}
